module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fBo3Z"))).then(() => module.bundle.root('5erN3'));